import type { ProductVendor } from "@models/product";
import { currencyFormatter } from "@utils/formatter";
import { stockLimitMessage } from "../../_helpers/stockCopy";
import type { LineStock } from "../_helpers/lineStock";

interface LineStockNoticeProps {
    quantity: number;
    stock: LineStock | undefined;
    // The vendor switch is the Cart's; Checkout shows the stock line alone.
    onSwitch?: (vendor: ProductVendor) => void;
    switchDisabled?: boolean;
}

// A cart line's vendor stock where it limits the line (#443 / C-07): AT the stock it
// explains the stepper's disabled +; ABOVE it the line can't be ordered, so it is an
// error, with a vendor that can supply the whole line offered when the page offers
// switches (the Cart does; Checkout does not).
// Under the stock it says nothing — the count is not a low-stock hint.
export const LineStockNotice = ({
    quantity,
    stock,
    onSwitch,
    switchDisabled = false,
}: LineStockNoticeProps) => {
    const limit =
        stock !== undefined && quantity >= stock.available
            ? stock.available
            : undefined;
    const above = limit !== undefined && quantity > limit;
    const alternative = above ? stock?.alternative : undefined;

    return (
        <>
            {limit !== undefined && (
                <p
                    data-testid="cart-item-stock"
                    role={above ? "alert" : undefined}
                    className={
                        above
                            ? "text-sm font-semibold text-error"
                            : "text-sm text-neutral/70"
                    }
                >
                    {stockLimitMessage(limit)}
                </p>
            )}
            {alternative && onSwitch && (
                <button
                    type="button"
                    onClick={() => onSwitch(alternative)}
                    disabled={switchDisabled}
                    className="btn btn-sm btn-outline btn-primary self-start"
                >
                    {`Switch to ${alternative.vendorName} (${currencyFormatter.format(alternative.price)})`}
                </button>
            )}
        </>
    );
};
